import { useLingui } from '@lingui/react';
import { CarleadCreationButton, CarleadCreationFormStep1, CarleadLicensePlate, defaultCarleadCreationLPFlow, PricedCarsCounter, useNormalFlowService, useStep1LPCarleadForm } from '@wkda/carlead-creation-components';
import cx from 'classnames';
import { useBookingAppConfiguration, useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import { ReturningCustomerPopup, TrustPilot } from '../../../../../../components';
import React from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadLicensePlateStep1CustomerPopup = _ref => {
  let {
    wide = false,
    headlineDesktop = 'carleadCreation.form.mainTitle',
    headlineMobile = 'carleadCreation.form.mainTitle.mobile',
    className = '',
    subheadline = false,
    showCounterHeadline = false
  } = _ref;
  const consumerForm = useStep1LPCarleadForm();
  const machine = useNormalFlowService(defaultCarleadCreationLPFlow);
  const {
    i18n
  } = useLingui();
  const {
    locale
  } = useBookingAppConfiguration();
  const country = locale === 'nl' ? 'NL' : 'SE';
  useTrackLanding();
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container license-plate step-1",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: `box gap full-height ${className}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: cx('container', {
          'container-xl': wide
        }),
        children: [showCounterHeadline ? /*#__PURE__*/_jsx(PricedCarsCounter, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-none d-md-block",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineDesktop)
            }
          }), /*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-block d-md-none",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineMobile)
            }
          })]
        }), subheadline && /*#__PURE__*/_jsx("p", {
          className: "carlead-creation-form__subheadline",
          children: i18n._(subheadline)
        }), /*#__PURE__*/_jsxs(CarleadCreationFormStep1, {
          carleadForm: consumerForm,
          machineService: machine,
          children: [/*#__PURE__*/_jsx(CarleadLicensePlate, {
            country: country
          }), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-md-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-md-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })]
  });
};
export default CarleadLicensePlateStep1CustomerPopup;